import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TopNavigation from '../../components/feature/TopNavigation';
import BottomNavigation from '../../components/feature/BottomNavigation';
import Card from '../../components/base/Card';
import Button from '../../components/base/Button';

export default function Projects() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<'active' | 'completed' | 'upcoming'>('active');

  const projects = {
    active: [
      {
        id: 1,
        title: 'معرض الرياض الدولي للتقنية',
        company: 'شركة المعارض السعودية',
        startDate: '2024-01-15',
        endDate: '2024-01-18',
        progress: 60,
        role: 'مضيف استقبال',
        dailyRate: '150 ريال',
        image: 'https://public.readdy.ai/ai/img_res/701d5e54388cf054d870add9bd58c27f.jpg',
        status: 'جاري العمل',
        location: 'مركز الرياض الدولي للمؤتمرات'
      },
      {
        id: 2,
        title: 'مهرجان الرياض للتسوق',
        company: 'الهيئة العامة للترفيه',
        startDate: '2024-01-20',
        endDate: '2024-01-25',
        progress: 25,
        role: 'منسق فعاليات',
        dailyRate: '200 ريال',
        image: 'https://readdy.ai/api/search-image?query=Vibrant%20shopping%20festival%20with%20colorful%20decorations%2C%20retail%20booths%2C%20festive%20atmosphere%2C%20modern%20mall%20setting%2C%20bright%20lighting%2C%20celebration%20theme&width=400&height=200&seq=project2&orientation=landscape',
        status: 'قيد التحضير',
        location: 'الرياض بارك'
      }
    ],
    completed: [
      {
        id: 3,
        title: 'مؤتمر الذكاء الاصطناعي',
        company: 'جامعة الملك سعود',
        startDate: '2024-01-05',
        endDate: '2024-01-07',
        progress: 100,
        role: 'مساعد تقني',
        dailyRate: '180 ريال',
        image: 'https://readdy.ai/api/search-image?query=Professional%20AI%20conference%20with%20modern%20presentation%20screens%2C%20tech%20setup%2C%20business%20audience%2C%20clean%20corporate%20environment%2C%20sophisticated%20lighting&width=400&height=200&seq=project3&orientation=landscape',
        status: 'مكتمل',
        location: 'مدينة الملك عبدالعزيز للعلوم',
        rating: 5,
        earnings: '540 ريال'
      }
    ],
    upcoming: [
      {
        id: 4,
        title: 'معرض الكتاب الدولي',
        company: 'وزارة الثقافة',
        startDate: '2024-02-01',
        endDate: '2024-02-10',
        progress: 0,
        role: 'مرشد زوار',
        dailyRate: '130 ريال',
        image: 'https://readdy.ai/api/search-image?query=International%20book%20fair%20with%20organized%20book%20displays%2C%20reading%20areas%2C%20cultural%20atmosphere%2C%20warm%20lighting%2C%20educational%20environment%2C%20visitors%20browsing&width=400&height=200&seq=project4&orientation=landscape',
        status: 'قريباً',
        location: 'مركز الرياض الدولي للمؤتمرات'
      }
    ]
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'جاري العمل': return 'text-[#4CAF50] bg-[#4CAF50]/10';
      case 'قيد التحضير': return 'text-[#FBC02D] bg-[#FBC02D]/10';
      case 'مكتمل': return 'text-[#607D8B] bg-[#607D8B]/10';
      case 'قريباً': return 'text-[#1565C0] bg-[#1565C0]/10';
      default: return 'text-[#757575] bg-[#F5F5F5]';
    }
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ar-SA', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  return (
    <div className="min-h-screen bg-[#FDFDFD]">
      <TopNavigation 
        title="مشاريعي"
        leftAction={
          <button 
            onClick={() => navigate('/dashboard')}
            className="w-8 h-8 flex items-center justify-center"
          >
            <i className="ri-arrow-right-line text-lg"></i>
          </button>
        }
        rightAction={
          <button className="w-8 h-8 flex items-center justify-center">
            <i className="ri-more-line text-lg"></i>
          </button>
        }
      />

      <div className="pt-14 pb-20 px-4">
        {/* Stats Cards */}
        <div className="grid grid-cols-3 gap-3 mb-6 mt-4">
          <Card className="text-center">
            <div className="w-10 h-10 bg-[#4CAF50]/10 rounded-full flex items-center justify-center mx-auto mb-2">
              <i className="ri-play-circle-line text-[#4CAF50]"></i>
            </div>
            <p className="text-2xl font-bold text-[#333333]">{projects.active.length}</p>
            <p className="text-[#757575] text-xs">نشط</p>
          </Card>
          <Card className="text-center">
            <div className="w-10 h-10 bg-[#607D8B]/10 rounded-full flex items-center justify-center mx-auto mb-2">
              <i className="ri-check-circle-line text-[#607D8B]"></i>
            </div>
            <p className="text-2xl font-bold text-[#333333]">{projects.completed.length}</p>
            <p className="text-[#757575] text-xs">مكتمل</p>
          </Card>
          <Card className="text-center">
            <div className="w-10 h-10 bg-[#1565C0]/10 rounded-full flex items-center justify-center mx-auto mb-2">
              <i className="ri-calendar-line text-[#1565C0]"></i>
            </div>
            <p className="text-2xl font-bold text-[#333333]">{projects.upcoming.length}</p>
            <p className="text-[#757575] text-xs">قادم</p>
          </Card>
        </div>

        {/* Tabs */}
        <div className="mb-6">
          <div className="flex bg-[#F5F5F5] rounded-lg p-1">
            {[
              { key: 'active', label: 'النشطة' },
              { key: 'completed', label: 'المكتملة' },
              { key: 'upcoming', label: 'القادمة' }
            ].map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key as any)}
                className={`flex-1 py-2 px-3 rounded-md text-sm font-medium transition-colors ${
                  activeTab === tab.key
                    ? 'bg-white text-[#1565C0] shadow-sm'
                    : 'text-[#607D8B]'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* Projects List */}
        <div className="space-y-4">
          {projects[activeTab].map((project) => (
            <Card key={project.id} className="hover:shadow-md transition-shadow">
              <div className="space-y-4">
                {/* Project Image */}
                <div className="relative h-32 rounded-lg overflow-hidden">
                  <img 
                    src={project.image} 
                    alt={project.title}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute top-2 right-2">
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(project.status)}`}>
                      {project.status}
                    </span>
                  </div>
                </div>

                {/* Project Info */}
                <div>
                  <h3 className="font-semibold text-[#333333] text-lg mb-1">{project.title}</h3>
                  <p className="text-[#607D8B] text-sm mb-2">{project.company}</p>
                  
                  <div className="space-y-2 mb-3">
                    <div className="flex items-center text-[#757575] text-sm">
                      <i className="ri-user-line ml-2"></i>
                      {project.role}
                    </div>
                    <div className="flex items-center text-[#757575] text-sm">
                      <i className="ri-map-pin-line ml-2"></i>
                      {project.location}
                    </div>
                    <div className="flex items-center text-[#757575] text-sm">
                      <i className="ri-calendar-line ml-2"></i>
                      {formatDate(project.startDate)} - {formatDate(project.endDate)}
                    </div>
                    <div className="flex items-center text-[#4CAF50] text-sm font-medium">
                      <i className="ri-money-dollar-circle-line ml-2"></i>
                      {project.dailyRate}
                    </div>
                  </div>

                  {/* Progress Bar (for active projects) */}
                  {activeTab === 'active' && (
                    <div className="mb-4">
                      <div className="flex justify-between items-center mb-2">
                        <span className="text-sm text-[#333333] font-medium">التقدم</span>
                        <span className="text-sm text-[#607D8B]">{project.progress}%</span>
                      </div>
                      <div className="w-full bg-[#F5F5F5] rounded-full h-2">
                        <div 
                          className="bg-[#1565C0] h-2 rounded-full transition-all duration-300"
                          style={{ width: `${project.progress}%` }}
                        ></div>
                      </div>
                    </div>
                  )}

                  {/* Rating (for completed projects) */}
                  {activeTab === 'completed' && 'rating' in project && (
                    <div className="mb-4">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center">
                          <span className="text-sm text-[#333333] font-medium ml-2">التقييم:</span>
                          <div className="flex">
                            {[...Array(5)].map((_, i) => (
                              <i 
                                key={i}
                                className={`ri-star-${i < (project as any).rating ? 'fill' : 'line'} text-[#FBC02D] text-sm`}
                              ></i>
                            ))}
                          </div>
                        </div>
                        <span className="text-[#4CAF50] font-semibold">{(project as any).earnings}</span>
                      </div>
                    </div>
                  )}

                  {/* Actions */}
                  <div className="flex gap-3">
                    {activeTab === 'active' && (
                      <>
                        <Button 
                          variant="primary" 
                          className="flex-1"
                          onClick={() => navigate(`/projects/${project.id}`)}
                        >
                          عرض التفاصيل
                        </Button>
                        <button className="w-12 h-12 border border-gray-200 rounded-lg flex items-center justify-center hover:bg-gray-50">
                          <i className="ri-message-line text-[#607D8B]"></i>
                        </button>
                      </>
                    )}
                    {activeTab === 'completed' && (
                      <>
                        <Button variant="secondary" className="flex-1">
                          عرض الشهادة
                        </Button>
                        <button className="w-12 h-12 border border-gray-200 rounded-lg flex items-center justify-center hover:bg-gray-50">
                          <i className="ri-download-line text-[#607D8B]"></i>
                        </button>
                      </>
                    )}
                    {activeTab === 'upcoming' && (
                      <Button 
                        variant="outline" 
                        className="flex-1"
                        onClick={() => navigate(`/projects/${project.id}`)}
                      >
                        عرض التفاصيل
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {projects[activeTab].length === 0 && (
          <div className="text-center py-12">
            <div className="w-16 h-16 bg-[#F5F5F5] rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-folder-line text-[#607D8B] text-2xl"></i>
            </div>
            <h3 className="text-lg font-semibold text-[#333333] mb-2">لا توجد مشاريع</h3>
            <p className="text-[#757575] mb-4">ابدأ بالتقديم على الوظائف المتاحة</p>
            <Button 
              variant="primary"
              onClick={() => navigate('/jobs')}
            >
              استعراض الوظائف
            </Button>
          </div>
        )}
      </div>

      <BottomNavigation />
    </div>
  );
}
